import { createReducer, on } from "@ngrx/store";
import { ApplicationDetailsActions } from "../actions/application-details.actions";
import { initialState } from "../states/application-details.state";

export const applicationDetailsReducer = createReducer(
  initialState,
  on(ApplicationDetailsActions.loadApplicationDetails, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    ApplicationDetailsActions.loadApplicationDetailsSuccess,
    (state, { applicationDetails }) => ({
      ...state,
      applications: applicationDetails,
      loading: false,
    })
  ),
  on(
    ApplicationDetailsActions.loadApplicationDetailsFailure,
    (state, { error }) => ({
      ...state,
      error,
      loading: false,
    })
  ),
  on(ApplicationDetailsActions.updateApplicationDetails, (state) => ({
    ...state,
    error: null,
  })),
  on(
    ApplicationDetailsActions.updateApplicationDetailsSuccess,
    (state, { updatedApplicationDetails }) => ({
      ...state,
      applications: updatedApplicationDetails,
      loading: false,
    })
  ),
  on(
    ApplicationDetailsActions.updateApplicationDetailsFailure,
    (state, { error }) => ({
      ...state,
      error,
      loading: false,
    })
  ),

  on(ApplicationDetailsActions.loadSideNavApplications, (state) => ({
    ...state,
    error: null,
  })),
  on(
    ApplicationDetailsActions.loadSideNavApplicationsSuccess,
    (state, { sideNavDetails }) => ({
      ...state,
      sideNavDetails: sideNavDetails,
      loading: false,
    })
  ),
  on(
    ApplicationDetailsActions.loadSideNavApplicationsFailure,
    (state, { error }) => ({
      ...state,
      error,
      loading: false,
    })
  ),
);
